import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
} from "@material-ui/core";
import Link from "@material-ui/core/Link";
import { NavLink } from "react-router-dom";
import { spacing } from "@material-ui/system";

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 64px - 48px - 106px - 48px - 64px);
  position: relative;
`;

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const AdminResources = () => {
  return (
    <>
      <Helmet title="Admin Resources" />
      <Typography variant="h3" gutterBottom display="inline">
        Admin Resources
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/dashboard">
          Dashboard
        </Link>
        <Typography>Admin Resources</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <Container>
        <iframe
          src="https://docs.google.com/presentation/d/e/2PACX-1vRJE2cGxPdgv9IooSxcFgCPcy59kKWSiOPYdAmQC5WSiJS3o1NR4DX41LHla34GjBC-DqfFBp6spCJo/embed?start=false&loop=false&delayms=3000"
          width="100%"
          height="100%"
          frameBorder="0"
          title="Admin Resources"
        />
      </Container>
    </>
  );
};

export default AdminResources;
